import { render } from "./assessment-v1-result.vue?vue&type=template&id=4949eae8&scoped=true"
import script from "./assessment-v1-result.vue?vue&type=script&lang=js"
export * from "./assessment-v1-result.vue?vue&type=script&lang=js"

import "./assessment-v1-result.vue?vue&type=style&index=0&id=4949eae8&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4949eae8"]])

export default __exports__